import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as paymentActions from '../_actions/payment';
import { Payment } from '../_models';

export interface PaymentState extends EntityState<Payment> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Payment> = createEntityAdapter<Payment>();

const initialState: PaymentState = adapter.getInitialState({
  loading: false,
  error: null,
});

const paymentReducer = createReducer(
  initialState,

  on(paymentActions.loadPayments, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(paymentActions.loadpaymentsSuccess, (state, { payments }) =>
    adapter.setAll(payments, { ...state, loading: false })
  ),

  on(paymentActions.loadpaymentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export function reducer(state: PaymentState | undefined, action: Action) {
  return paymentReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
